import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackEnterVideoEditMode.meta';

export const useTrackEnterVideoEditMode = () => {
  const { track } = useAnalyticsUtilities();

  const trackEnterVideoEditMode = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackEnterVideoEditMode };
};
